/* eslint-disable no-unused-vars */
/* eslint-disable react/display-name */

import React, { useEffect, useMemo, useState } from 'react';
import MaterialTable from 'material-table';
import { useDispatch, useSelector } from 'react-redux';
import { CreatorsAnchors } from '../../../../store/ducks/anchors';

import { Button } from '@material-ui/core';
import { Link } from 'react-router-dom';

import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import CloseIcon from '@material-ui/icons/Close';

import useStyles from './style';

import { findPermission } from '../../../../services/auth';

function GridAncorasContato({ ancoraId, visualize, findAllAncorasContatos, getAncorasContatos }) {
  const classes = useStyles();

  const { filters } = useSelector((state) => state.anchors);
  const [anchorContacts, setAnchorContacts] = useState([]);

  const anchorFilter = filters.find((x) => x.anchor === 'ancoras-contatos');

  const dispatch = useDispatch();

  const memoizedTable = useMemo(
    () => (
      <MaterialTable
        className={classes.table}
        options={{
          showTitle: false,
          search: false,
          toolbar: false,
          headerStyle: {
            backgroundColor: '#F5F5F5',
            textTransform: 'none',
            fontSize: '15px',
          },
          filtering: true,
          paging: false,
        }}
        title="Multiple Actions Preview"
        columns={[
          {
            title: 'Nome',
            field: 'nome',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
              width: '150px',
            },
          },
          {
            title: 'E-mail',
            field: 'email',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
              width: '150px',
            },
          },
          {
            title: 'Telefone1',
            field: 'telefone1',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
              width: '15%',
            },
          },
          {
            title: 'Telefone2',
            field: 'telefone2',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
              width: '15%',
            },
          },
          {
            title: 'E-mail de Aprovação',
            field: 'receberEmailAntecipacoesAprovadas',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'E-mail de Fechamento Mês',
            field: 'receberEmailFechamentoMes',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
            },
          },
          {
            title: 'Status',
            field: 'status',
            cellStyle: {
              fontSize: '13px',
              padding: '8px 16px',
              width: '7%',
            },
          },
          {
            title: 'Ações',
            field: 'actions',
            headerStyle: {
              textAlign: 'center',
            },
            cellStyle: {
              fontSize: '13px',
              textAlign: 'center',
              padding: '8px 16px',
            },
            filtering: false,
            sorting: false,
            render: (rowData) =>
              !!rowData.ancoraContatoId && (
                <>
                  {!!findPermission(1554, 'Consultar') && (
                    <Link
                      className={classes.buttonVisualize}
                      to={`/app/ancoras-contatos/visualizar/${rowData.ancoraContatoId}`}
                    >
                      <VisibilityIcon style={{ fontSize: 30, color: '#4AAF05' }} />
                    </Link>
                  )}
                  {!!findPermission(1554, 'Alterar') && !visualize && (
                    <Link
                      className={classes.buttonEdit}
                      to={`/app/ancoras-contatos/editar/${rowData.ancoraContatoId}`}
                    >
                      <EditIcon style={{ fontSize: 30, color: '#FB8832' }} />
                    </Link>
                  )}
                </>
              ),
          },
        ]}
        data={anchorContacts}
      />
    ),
    [anchorContacts],
  );

  useEffect(() => {
    if (getAncorasContatos.length > 0 && !getAncorasContatos[0].message) {
      setAnchorContacts(
        getAncorasContatos.map((contact) => ({
          ...contact,
          telefone1:
            `${contact?.telefone1}` + (contact?.ramal1 ? ` Ramal: ${contact?.ramal1}` : ''),
          telefone2:
            `${contact?.telefone2}` + (contact?.ramal2 ? ` Ramal: ${contact?.ramal2}` : ''),
        })),
      );
    } else {
      setAnchorContacts(
        getAncorasContatos.map((contact) => ({
          ...contact,
          telefone1: '',
          telefone2: '',
          receberEmailAntecipacoesAprovadas: '',
          receberEmailFechamentoMes: '',
        })),
      );
    }
  }, []);

  return (
    <>
      <div className={classes.actions}>
        <Button
          variant="contained"
          onClick={() => dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-contatos' }))}
          className={classes.button}
        >
          <span>Filtros</span>
        </Button>
        {!visualize && !!findPermission(1554, 'Cadastrar') && (
          <Link className={classes.button} to={`/app/ancoras-contatos/${ancoraId}/cadastrar`}>
            Novo Item
          </Link>
        )}
        {!!anchorFilter.open && (
          <div className={classes.filtersBox}>
            <div className={classes.headFilter}>
              <span className={classes.labelFilter}>Status:</span>
              <button
                className={classes.buttonClose}
                onClick={() =>
                  dispatch(CreatorsAnchors.changeModal({ anchor: 'ancoras-contatos' }))
                }
              >
                <CloseIcon style={{ fontSize: 25, color: '#fff' }} />
              </button>
            </div>

            <select
              onChange={(event) =>
                dispatch(
                  CreatorsAnchors.changeFilter({
                    anchor: 'ancoras-contatos',
                    filter: event.target.value,
                  }),
                )
              }
              value={anchorFilter.filter}
              className={classes.selectStatus}
            >
              <option value="">Todos</option>
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
            <button className={classes.buttonFilter} onClick={() => findAllAncorasContatos()}>
              Aplicar Filtro
            </button>
          </div>
        )}
      </div>
      {memoizedTable}
    </>
  );
}

export default GridAncorasContato;
